const importFileExtensions = { CSV: 'csv', XLSX: 'xlsx' };

export default importFileExtensions;